import React from 'react';

const CommonTextarea = ({ 
    name,
    label,
    value,
    onChange,
    placeholder = '',
    required = false,
    disabled = false,
    errors,
    className = 'mb-3 ',
    rows = 3,
    ...props
}) => {
    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                className={`form-control ${errors?.[name] ? 'is-invalid' : ''}`}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
                {...props}
            />
            {errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonTextarea; 